<template>
    <div>
        <div class="f-list-page">
            <veui-pagination class="f-list-page-page"
                v-if="changeUrl"
                :page="page"
                :total="pageInfo.recordTotal"
                :page-size="pageInfo.pageSize"
                :to="to"
            />
            <forum-pagination
                v-else
                :page="page"
                :total="pageInfo.recordTotal"
                :page-size="pageInfo.pageSize"
                :page-count="pageInfo.pageTotal"
                @page-change="navToPage">
            </forum-pagination>
            <span class="f-list-page-total">
                共{{pageInfo.pageTotal}}页,到第
                <input class="f-list-page-total-input"
                    v-model="pageNo"
                    @input="isOutsidePage"
                    @keyup.enter="navToPage(pageNo)">
                页
                <span class="f-list-page-total-confirm" @click="navToPage(pageNo)">确定</span>
            </span>
        </div>
    </div>
</template>

<style lang="less">
    @import '../../../assets/less/components/page.less';
</style>

<script>
import {Pagination} from 'veui';
import PaginationWithoutRouter from './Pagination.vue';

import {throttle} from '@/utils/debounceThrottle';

export default {
    props: {
        pageInfo: {
            'type': Object,
            'default': {}
        },
        changeUrl: {
            'type': Boolean,
            'default': true
        },
        navMethod: {
            'type': Boolean,
            'default': false
        }
    },
    data() {
        return {
            pageNo: ''
        };
    },
    components: {
        'veui-pagination': Pagination,
        'forum-pagination': PaginationWithoutRouter
    },
    computed: {
        page() {
            return +this.pageInfo.pageNo || 1;
        },
        to() {
            this.clearPageNo();
            let path = this.$route.fullPath;
            if (path.match(/pageNo=/)) {
                path = path.replace(/pageNo=[0-9]*/, match => {
                    return 'pageNo=:page';
                });
            }
            else {
                if (path.indexOf('?') > -1) {
                    path += '&pageNo=:page';
                }
                else {
                    path += '?pageNo=:page';
                }
            }
            this.$emit('to');
            return path;
        }
    },
    methods: {
        navToPage: throttle(function (pageNo) {
            if (pageNo) {
                if (this.navMethod) {
                    this.$emit('navToPage', pageNo);
                }
                else {
                    let name = this.$route.name;
                    let params = Object.assign({}, this.$route.params);
                    let query = Object.assign({}, this.$route.query);
                    query.pageNo = +pageNo;
                    this.$router.push({name, params, query});
                }
            }
        }),
        isOutsidePage() {
            if (+this.pageNo > +this.pageInfo.pageTotal) {
                this.pageNo = this.pageInfo.pageTotal;
            }
            if (this.pageNo && +this.pageNo < 1) {
                this.pageNo = 1;
            }
        },
        clearPageNo() {
            this.pageNo = '';
        }
    }
};
</script>
